<template>
  <PageContainer>
    <div v-if="loading && !profileNotFound" class="loading">
      <NumeraiLoader />
    </div>
    <PageNotFound v-else-if="profileNotFound"></PageNotFound>
    <div v-else>
      <ProfileInfo
        :profile="profile"
        :is-model-owner="isModelOwner"
        :is-dark-mode="isDarkMode"
        :profile-change-callback="fetchProfile"
      />
      <!-- These props are passed to the components that
          are shown here. See routes.js -->
      <router-view
        :profile="profile"
        :account-info="accountInfo"
        :is-model-owner="isModelOwner"
        :nmr-price="nmrPrice"
        :fetch-profile="fetchProfile"
        :username="username"
        :is-mobile="isMobile"
        :is-dark-mode="isDarkMode"
      ></router-view>
      <Footer class="mt-2" />
    </div>
  </PageContainer>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import ProfileInfo from '@/components/profile/ProfileInfo'
import { PageContainer, NumeraiLoader } from '@/components/shared'
import PageNotFound from '@/pages/PageNotFound'
import Footer from '@/components/hud/Footer.vue'
import Analytics from '@/lib/analytics'
// for some reason, linter doesn't see usages of isAppSignals
// eslint-disable-next-line
import { isAppSignals, getTournamentNumber } from '@/lib/utils'

export default {
  components: {
    PageContainer,
    ProfileInfo,
    NumeraiLoader,
    PageNotFound,
    Footer,
  },
  props: {
    isMobile: { type: Boolean, default: false },
  },
  data() {
    return {
      profileNotFound: false,
      profile: null,
    }
  },
  computed: {
    ...mapState([
      'userProfiles',
      'signalsUserProfiles',
      'accountInfo',
      'selectedProfileView',
      'selectedRoundNumber',
    ]),
    ...mapGetters(['modelNames', 'nmrPrice', 'isDarkMode', 'isLoggedIn']),
    username() {
      return this.$route.params.username
    },
    profileUsername() {
      if (!this.profile) {
        return null
      }
      return this.profile.username
    },
    isModelOwner() {
      if (this.isLoggedIn && this.modelNames && this.profile) {
        return this.modelNames.includes(this.profile.username)
      } else {
        return false
      }
    },
    loading() {
      if (!this.profile && !this.profileNotFound) return true
      return false
    },
  },
  watch: {
    // whenever the username changes, we need to reload the profile
    // this happens when you are on someone elses profile and you
    // click `profile` to go to your own
    '$route.params.username': async function() {
      this.profileNotFound = false
      await this.load()
    },
    /* eslint-disable */
    isLoggedIn: function(newState, oldState) {
      if (newState == true) {
        this.$store.dispatch('fetchAccountInfo').then(() => this.fetchProfile())
      }
    },
    /* eslint-enable */
  },
  mounted() {
    Analytics.track('page view', {
      page: 'model profile page',
      tournament: getTournamentNumber(),
    })
  },
  async created() {
    await this.load()
  },
  methods: {
    async load() {
      try {
        if (this.username !== this.username.toLowerCase()) {
          this.$router.push('/' + this.username.toLowerCase())
          return
        }
        /* TODO: Could check if modelNames is populated and if
        this profile exists in it instead of fetching account on each page load
        for everyone who's logged in and visits. But it's async so not
        slowing down the load. */
        if (this.isLoggedIn) {
          this.$store.dispatch('fetchAccountInfo')
        }
        await this.fetchProfile()

        /* profileUsername is the username returned by the API which might be
        different than what was used to query for it. In this case, lets
        redirect to the /profileUsername */
        if (this.username != this.profileUsername) {
          this.$router.push('/' + this.profileUsername.toLowerCase())
        }
      } catch (e) {
        this.profileNotFound = true
      }
    },
    async fetchProfile() {
      this.profile = await this.$client.getV3UserProfile({
        username: this.username,
        tournament: getTournamentNumber(),
      })
    },
  },
}
</script>
<style scoped lang="scss">
.loading {
  width: 100%;
  height: 100%;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
